/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhprivate10Inputs */

const en__field_enum_ikhprivate10 = /** @type {(inputs: _Field_Enum_Ikhprivate10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const de__field_enum_ikhprivate10 = /** @type {(inputs: _Field_Enum_Ikhprivate10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {_Field_Enum_Ikhprivate10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhprivate10 = /** @type {((inputs?: _Field_Enum_Ikhprivate10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhprivate10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhprivate10(inputs)
	return de__field_enum_ikhprivate10(inputs)
});
export { _field_enum_ikhprivate10 as "_field_enum_IKHPRIVATE" }